import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

// Public, static, no-auth marketing site. No ConvexProvider, no ClerkProvider —
// the demo is entirely client-side (precomputed dataset + browser probes), so
// there is nothing to authenticate against and no backend to wire.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
